export const OVERLAY_TYPES = [
  { value: 'numeric',   label: 'Number' },
  { value: 'bar',       label: 'Bar' },
  { value: 'gauge',     label: 'Gauge' },
  { value: 'graph',     label: 'Graph' },
  { value: 'laptime',   label: 'Lap Time' },
  { value: 'lap_table', label: 'Lap Table' },
  { value: 'track_map', label: 'Track Map' },
];

// Overlay types whose VTR spec has a required `channel` field. If one is sent
// without a channel, VTR rejects the whole request (422) and the backend
// re-wraps it as an opaque 502. `track_map` is the only channel-less type.
export const CHANNEL_REQUIRED_TYPES = new Set([
  'numeric', 'bar', 'gauge', 'graph', 'laptime', 'lap_table',
]);

// Return the overlays that require a channel but don't have one set.
export function overlaysMissingChannel(overlays) {
  return overlays.filter(o => CHANNEL_REQUIRED_TYPES.has(o.type) && !o.channel);
}

export const OVERLAY_TYPE_ICONS = {
  numeric:   '',
  bar:       '▬',
  gauge:     '◎',
  graph:     '〜',
  laptime:   '⏱',
  lap_table: '☰',
  track_map: '⬡',
};

export const OVERLAY_DEFAULT_SIZE = {
  numeric:   { width: 0.12, height: 0.07 },
  bar:       { width: 0.15, height: 0.08 },
  gauge:     { width: 0.15, height: 0.15 },
  graph:     { width: 0.28, height: 0.15 },
  laptime:   { width: 0.22, height: 0.13 },
  lap_table: { width: 0.25, height: 0.22 },
  track_map: { width: 0.18, height: 0.18 },
};

export const TYPE_COLORS = {
  numeric: [
    { field: 'text_color',       label: 'Text',  defaultRgb: [255, 255, 255] },
    { field: 'value_color',      label: 'Value', defaultRgb: [255, 255, 255] },
    { field: 'background_color', label: 'BG',    defaultRgb: [0, 0, 0] },
  ],
  bar: [
    { field: 'fill_color',       label: 'Fill',  defaultRgb: [232, 65, 26] },
    { field: 'background_color', label: 'BG',    defaultRgb: [0, 0, 0] },
    { field: 'text_color',       label: 'Text',  defaultRgb: [255, 255, 255] },
  ],
  gauge: [
    { field: 'fill_color',       label: 'Fill',  defaultRgb: [232, 65, 26] },
    { field: 'background_color', label: 'BG',    defaultRgb: [0, 0, 0] },
    { field: 'text_color',       label: 'Text',  defaultRgb: [255, 255, 255] },
    { field: 'value_color',      label: 'Value', defaultRgb: [255, 255, 255] },
    { field: 'warn_color',       label: 'Warn',  defaultRgb: [255, 50, 50] },
  ],
  laptime: [
    { field: 'text_color',       label: 'Text',  defaultRgb: [255, 255, 255] },
    { field: 'background_color', label: 'BG',    defaultRgb: [0, 0, 0] },
  ],
  lap_table: [
    { field: 'text_color',       label: 'Text',  defaultRgb: [255, 255, 255] },
    { field: 'background_color', label: 'BG',    defaultRgb: [0, 0, 0] },
  ],
  graph: [
    { field: 'line_color',       label: 'Line',  defaultRgb: [255, 64, 64] },
    { field: 'background_color', label: 'BG',    defaultRgb: [0, 0, 0] },
    { field: 'text_color',       label: 'Text',  defaultRgb: [255, 255, 255] },
  ],
  track_map: [
    { field: 'track_color',      label: 'Track', defaultRgb: [120, 120, 120] },
    { field: 'car_color',        label: 'Car',   defaultRgb: [232, 65, 26] },
    { field: 'tail_color',       label: 'Tail',  defaultRgb: [255, 255, 255] },
    { field: 'background_color', label: 'BG',    defaultRgb: [0, 0, 0] },
  ],
};

export function rgbToHex([r, g, b]) {
  return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('');
}

export function hexToRgb(hex) {
  return [
    parseInt(hex.slice(1, 3), 16),
    parseInt(hex.slice(3, 5), 16),
    parseInt(hex.slice(5, 7), 16),
  ];
}
